import { fetchQuery, graphql } from "relay-runtime"
import {
  AiRequestMetadataInput,
  chReferralLetterCopilotQuery as ChReferralLetterCopilotQueryType,
} from "@/modules/patients/detail/referral/services/ch/__generated__/chReferralLetterCopilotQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query chReferralLetterCopilotQuery($aiRequestMetadata: AiRequestMetadataInput!) {
    referralLetterCopilot: ch_referralLetterCopilot(aiRequestMetadata: $aiRequestMetadata) {
      text
      result
      fileHash
      aiRequestDurationMs
      aiAnonymizationRequestDurationMs
    }
  }
`

export const chReferralLetterCopilotQuery = (aiRequestMetadata: AiRequestMetadataInput) => {
  return fetchQuery<ChReferralLetterCopilotQueryType>(RelayEnvironment, query, {
    aiRequestMetadata,
  }).toPromise()
}
